import Typography from '@mui/material/Typography';
import { AvailableTimes } from '../../../interfaces';
import { cx } from '../../../helpers/global';

type Props = {
  time: AvailableTimes;
  onChange: (value: Date) => void;
  closeModal: any;
  isSelected?: boolean;
  disabled?: boolean;
  keepOpen?: boolean;
};

export default function Time({
  time,
  onChange,
  closeModal,
  isSelected,
  disabled,
  keepOpen,
}: Props) {
  const dateTime = new Date(time.startDateTime);

  function clickHandle(datetime: Date) {
    if (disabled) return;
    onChange(datetime);
    if (!keepOpen) closeModal();
  }

  return (
    <div
      role="presentation"
      className={cx(
        'time-item',
        isSelected && 'selected',
        disabled && 'disabled',
      )}
      title={disabled ? 'Remove a time to pick a different one' : undefined}
      onClick={() => {
        clickHandle(dateTime);
      }}>
      <Typography variant="h3">{time.displayTime}</Typography>
    </div>
  );
}
